import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence, signInWithPopup, GoogleAuthProvider, signOut as fbSignOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const FALLBACK_CONFIG = {
  apiKey: "AIzaSyBQ6tp5ICNqKQygYBePXQyhQWNqBkWrE3I",
  authDomain: "makeyourcrew-58241.firebaseapp.com",
  projectId: "makeyourcrew",
  storageBucket: "makeyourcrew.firebasestorage.app",
  messagingSenderId: "91151303483",
  appId: "1:91151303483:web:8e0b196b0a5ecefb7d3b37",
};

function loadConfig() {
  try {
    const raw = import.meta.env.VITE_FIREBASE_CONFIG;
    if (raw) return JSON.parse(raw);
  } catch {}
  return FALLBACK_CONFIG;
}

const app = initializeApp(loadConfig());
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west1");

export { auth, db, functions };
